<script>
  import { inertia, page } from '@inertiajs/svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let type = 'default';
  export let image = {};
  export let level;
  export let title;
  export let url;
  export let desc;
  export let icon;
  let grow = false;
</script>

<article
  class="vacancy-item"
  class:vacancy-item--related={type === 'related'}
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <a href={url}>
    {#if type === 'featured' && image}
      <div class="vacancy-item__image" use:inertia>
        <img
          src={image.src}
          width="415"
          height="415"
          alt={image.alt}
          loading="lazy"
        />
      </div>
    {/if}

    <p class="text-small vacancy-item__level">{level}</p>

    <div class="vacancy-item__title">
      {#if type !== 'related' && icon}
        <img
          src={icon.src}
          width="30"
          height="30"
          alt={icon.alt}
          loading="lazy"
        />
      {/if}
      <h3 class="h6">{title}</h3>
    </div>

    <hr />
    {#if type === 'related' && desc}
      <p class="vacancy-item__desc text-small">{desc}</p>
    {/if}
    <p class="vacancy-item__link text-small text-link" use:inertia>
      <span>{$page.props.i18n.view_vacancy}</span>
    </p>
  </a>
</article>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .vacancy-item {
    break-inside: avoid-column;

    padding: 5rem 4rem;
    border-radius: 2rem;
    border: 1px solid transparent;
    background-color: rgb(var(--white));

    box-shadow: 3px 3px 0 0 rgba(var(--black), 0.02);
    cursor: pointer;
    transition: all 1s ease-in-out;

    @include resp-max('s') {
      padding: 3rem;
    }

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &:not(:first-child) {
      margin-top: 3.4rem;
    }

    &:hover {
      .vacancy-item__image img {
        transform: scale(1.1);
      }
      .text-link {
        color: var(--royal);
      }
    }

    &__image {
      display: block;
      position: relative;

      border-radius: 4px;
      overflow: hidden;

      margin: 0 0 2rem;

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: url(img/noise.png) 300px 300px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 1s cubic-bezier(0.22, 1, 0.36, 1);
      }
    }

    &__level {
      color: var(--royal-light);
    }

    &__title {
      display: flex;
      gap: 1rem;
      margin-top: 1rem;
    }

    hr {
      margin: 2rem 0;
      border: unset;
      height: 1px;
      background-color: $light-border;
    }

    &__desc {
      color: var(--royal-light);
      margin-bottom: 2rem;
      overflow: hidden;
      max-height: 5.5rem;
    }

    &--related {
      height: 34rem;
      position: relative;
      .vacancy-item {
        &__link {
          position: absolute;
          left: 4rem;
          bottom: 5rem;
        }
      }
    }
  }
</style>
